<template>
  <v-combobox
    v-bind="$attrs"
    v-on="$listeners"
    :items="fonctions"
    @update:search-input="updateInputValue"
     aria-autocomplete="none"
    :data-testid="dataTestid"
  />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fonctions: [
        { header: "Sélectionner une valeur, ou saisissez une valeur autre" },
        "Président(e)",
        "Trésorier(ère)",
        "Secrétaire",
        "Vice-Président(e)",
        "Trésorier(ère) adjoint(e)",
        "Secrétaire adjoint(e)",
        "Assesseur(e)",
        "Membre"
      ],
    };
  },
  methods: {
    updateInputValue(value) {
      // Mettre à jour la valeur saisie
      this.$emit("input", value);
    }
  }
};
</script>
